'use client';
import React from 'react';

interface FooterProps {
  transparent?: boolean;
  textColor?: string;
  transparentBorder?: boolean;
}

const Footer: React.FC<FooterProps> = ({
  transparent = false,
  textColor = 'text-text-white',
  transparentBorder = false,
}) => {
  return (
    <footer data-component-id="src/components/common/Footer.tsx:16:4" data-component-path="src/components/common/Footer.tsx" data-component-line="16" data-component-end-line="26" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%7D"
      className={`h-[83px] w-full ${transparent ? '' : 'bg-primary-darker'} ${transparentBorder ? '' : 'border-t border-text-white'}`}
    >
      <div data-component-id="src/components/common/Footer.tsx:19:6" data-component-path="src/components/common/Footer.tsx" data-component-line="19" data-component-end-line="25" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20w-full%20max-w-7xl%20mx-auto%20px-4%20sm%3Apx-8%20md%3Apx-16%20lg%3Apx-24%20xl%3Apx-%5B108px%5D%22%7D" className="h-full w-full max-w-7xl mx-auto px-4 sm:px-8 md:px-16 lg:px-24 xl:px-[108px]">
        <div data-component-id="src/components/common/Footer.tsx:20:8" data-component-path="src/components/common/Footer.tsx" data-component-line="20" data-component-end-line="24" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20py-8%22%7D" className="flex justify-center items-center py-8">
          <p data-component-id="src/components/common/Footer.tsx:21:10" data-component-path="src/components/common/Footer.tsx" data-component-line="21" data-component-end-line="23" data-component-file="Footer.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22textContent%22%3A%22Sirio%20Strategies%20%C2%A9%202025%22%7D" className={`text-sm font-normal leading-[18px] ${textColor} text-center`}>
            Sirio Strategies © 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
